import axios from "axios";

const api = axios.create({
  baseURL: "https://api-geral.redeprocursos.com.br/processo",
  // baseURL: "http://localhost:3001/processo",
  headers: {
    "Content-Type": "application/json"
  },
});

export default api